import { render, staticRenderFns } from "./ErrorSubmitForm3.vue?vue&type=template&id=1ab9dbb4&scoped=true"
import script from "./ErrorSubmitForm3.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9dbb4",
  null
  
)

export default component.exports